import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TariffComponent } from '../tariff/tariff.component';
import { ApiService, ProductSet } from 'src/app/services/api.service';
import { HttpParams } from '@angular/common/http';
import { SwiperComponent } from '../swiper/swiper.component';
import { SwiperOptions } from 'swiper/types';

/**
 * Tariff carousel component for displaying product tariffs in a swipeable carousel.
 *
 * @remarks Fetches and displays showcase products in a responsive carousel layout
 * using Swiper.js. Filters specific products from the API response to showcase
 * featured tariff plans with adaptive breakpoints for different screen sizes.
 */
@Component({
  selector: 'app-tariff-carousel',
  templateUrl: './tariff-carousel.component.html',
  styleUrls: ['./tariff-carousel.component.scss'],
  standalone: true,
  imports: [CommonModule, TariffComponent, SwiperComponent],
})
export class TariffCarouselComponent implements OnInit {
  /** @remarks Array of showcase products filtered from the API response */
  public showcase = [];

  /** @remarks Swiper configuration options for responsive carousel behavior */
  public swiperOptions: SwiperOptions = {
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  };

  /**
   * Creates an instance of TariffCarouselComponent.
   *
   * @param apiService - Service for API communication to fetch product data
   */
  constructor(private apiService: ApiService) {}

  /**
   * Component initialization lifecycle hook.
   *
   * @remarks Fetches showcase products from the API and filters specific
   * product IDs (7797, 7803, 7824) to display featured tariff plans in the carousel.
   * Handles API errors gracefully with console logging.
   */
  ngOnInit() {
    // Get Showcased Products
    const params = new HttpParams().set('id', '129');

    this.apiService.get<ProductSet>('/productSet', params).subscribe({
      next: (data: ProductSet) => {
        this.showcase = data.articles.base.filter(product => ['7797', '7803', '7824'].includes(product.product_id));
      },
      error: error => {
        console.error(error);
      },
    });
  }
}
